(() => {
  const cache = {};

  const getHandle = (href) => {
    if (!href) return null;
    const parts = href.split("/products/");
    if (parts.length < 2) return null;
    return parts[1].split("?")[0].split("#")[0].split("/")[0] || null;
  };

  /** 详情页 Liquid 用 tag.fontcolor.value；接口 JSON 里可能是字符串或 { red, green, blue } */
  const colorToCss = (v) => {
    if (v == null || v === "") return "";
    if (typeof v === "string") return v.trim();
    if (typeof v === "object" && v.red != null && v.green != null && v.blue != null) {
      return `rgb(${v.red}, ${v.green}, ${v.blue})`;
    }
    return "";
  };

  const colorToTriplet = (v) => {
    if (v != null && typeof v === "object" && v.red != null && v.green != null && v.blue != null) {
      return `${v.red}, ${v.green}, ${v.blue}`;
    }
    if (typeof v === "string") {
      const hex = v.trim();
      if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(hex)) {
        const n = hex.length === 4
          ? `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`
          : hex;
        const r = parseInt(n.slice(1, 3), 16);
        const g = parseInt(n.slice(3, 5), 16);
        const b = parseInt(n.slice(5, 7), 16);
        return `${r}, ${g}, ${b}`;
      }
    }
    return "";
  };

  const fetchMetafields = async (handle) => {
    if (handle in cache) return cache[handle];
    try {
      // Section 接口易被浏览器/CDN 缓存成旧 JSON（例如 fontcolor 刚加时为空白），必须绕过 HTTP 缓存
      const resp = await fetch(
        `/products/${encodeURIComponent(handle)}?sections=product-metafield-api`,
        { cache: "no-store" }
      );
      const sections = await resp.json();
      const raw = sections["product-metafield-api"] || "";
      const first = raw.indexOf("{");
      const last = raw.lastIndexOf("}");
      const parsed =
        first !== -1 && last !== -1 ? JSON.parse(raw.substring(first, last + 1)) : {};
      cache[handle] = parsed;
    } catch {
      cache[handle] = {};
    }
    return cache[handle];
  };

  const buildTagBadgesHtml = (data) =>
    (data.tags || [])
      .filter((tag) => tag?.title)
      .map((tag) => {
        const slug = tag.title
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-|-$/g, "");
        const parts = [];
        const bgTriplet = colorToTriplet(tag.color);
        if (bgTriplet) parts.push(`--badge-background:${bgTriplet}`);
        const fontTriplet = colorToTriplet(tag.fontcolor);
        if (fontTriplet) parts.push(`--badge-color:${fontTriplet}`);
        const bgCss = colorToCss(tag.color);
        if (bgCss && !bgTriplet) parts.push(`background:${bgCss}`);
        const style = parts.length ? ` style="${parts.join(";")}"` : "";
        return `<span class="badge badge--tag badge--${slug}"${style}>${tag.title}</span>`;
      })
      .join("");

  const buildMegaMenuTagBoxHtml = (data) =>
    (data.tags || [])
      .filter((tag) => tag?.title)
      .map((tag) => {
        const slug = tag.title
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-|-$/g, "");
        const styles = [];
        const bg = colorToCss(tag.color);
        const font = colorToCss(tag.fontcolor);
        if (bg) styles.push(`background-color:${bg}`);
        if (font) styles.push(`color:${font}`);
        const style = styles.length ? ` style="${styles.join(";")}"` : "";
        return `<div class="product-tag-item product-tag-meta product-tag-meta--${slug}"${style}>${tag.title}</div>`;
      })
      .join("");

  /** 自定义 mega menu：仅展示产品元字段 custom.tag（Metaobject list） */
  const injectCustomMegaMenuTags = () => {
    document.querySelectorAll(".megamenu-box .site-nav-product-right-item-content-cell").forEach((cell) => {
      const link = cell.querySelector("a[href*='/products/']");
      if (!link) return;
      const handle = getHandle(link.getAttribute("href"));
      if (!handle || cell.dataset.ghMegaTagsDone) return;
      cell.dataset.ghMegaTagsDone = "1";

      fetchMetafields(handle).then((data) => {
        cell.querySelectorAll(".product-tag-sale").forEach((el) => el.remove());
        const tagHtml = buildMegaMenuTagBoxHtml(data);
        let box = cell.querySelector(".product-tag-box");
        if (!tagHtml) {
          box?.remove();
          return;
        }
        if (!box) {
          box = document.createElement("div");
          box.className = "product-tag-box";
          link.insertBefore(box, link.firstChild);
        } else {
          box.innerHTML = "";
        }
        box.insertAdjacentHTML("beforeend", tagHtml);
      });
    });
  };

  const replaceMegaMenuTitles = () => {
    document.querySelectorAll(".gm-submenu.gm-mega .gm-product-name").forEach((el) => {
      const link = el.closest("a");
      if (!link) return;
      const handle = getHandle(link.getAttribute("href"));
      if (!handle || el.dataset.mfDone) return;
      el.dataset.mfDone = "1";
      fetchMetafields(handle).then((data) => {
        if (data.short_title) el.textContent = data.short_title;
      });
    });
  };

  /** 与 short_title 相同：从 `.gm-submenu.gm-mega .gm-product-name` → `closest('a')` → handle → Section API */
  const injectMegaMenuBadges = () => {
    document.querySelectorAll(".gm-submenu.gm-mega .gm-product-name").forEach((nameEl) => {
      const link = nameEl.closest("a");
      if (!link) return;
      const handle = getHandle(link.getAttribute("href"));
      if (!handle || link.dataset.ghGmTagsDone) return;
      link.dataset.ghGmTagsDone = "1";

      fetchMetafields(handle).then((data) => {
        const badgeHtml = buildTagBadgesHtml(data);
        if (!badgeHtml) return;

        let row = link.querySelector(".gm-mega-badge-list");
        if (!row) {
          row = document.createElement("div");
          row.className = "gm-mega-badge-list";
          const anchor = link.querySelector("img") || nameEl;
          anchor.parentNode.insertBefore(row, anchor);
        }
        row.querySelectorAll(".badge--tag").forEach((b) => b.remove());
        row.insertAdjacentHTML("beforeend", badgeHtml);
      });
    });
  };

  const injectCollectionBadges = () => {
    document.querySelectorAll(".product-list product-card, product-card").forEach((card) => {
      if (card.dataset.badgesDone) return;
      const handleAttr =
        card.getAttribute("handle") ||
        getHandle(card.querySelector("a[href*='/products/']")?.getAttribute("href"));
      if (!handleAttr) return;
      card.dataset.badgesDone = "1";

      fetchMetafields(handleAttr).then((data) => {
        let badgeContainer = card.querySelector(".product-card__badge-list");
        if (!badgeContainer) {
          const figure = card.querySelector(".product-card__figure");
          if (!figure) return;
          badgeContainer = document.createElement("div");
          badgeContainer.className = "product-card__badge-list";
          figure.insertBefore(badgeContainer, figure.firstChild);
        }

        badgeContainer.querySelectorAll(".badge--tag").forEach((b) => b.remove());

        const badgeHtml = buildTagBadgesHtml(data);
        if (badgeHtml) badgeContainer.insertAdjacentHTML("beforeend", badgeHtml);
      });
    });
  };

  const runAll = () => {
    replaceMegaMenuTitles();
    injectMegaMenuBadges();
    injectCustomMegaMenuTags();
    injectCollectionBadges();
  };

  const observer = new MutationObserver(runAll);
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(runAll, 2000);
    setTimeout(runAll, 5000);
  });
})();
